import NewUser from "../components/UserManagement/New/NewUser";

const NewUserPage = (props) => {
    return <NewUser />
}

export default NewUserPage;